import { render, staticRenderFns } from "./studioDashboardEmployeeTargetHoursDialog.vue?vue&type=template&id=56239175&scoped=true"
import script from "./studioDashboardEmployeeTargetHoursDialog.vue?vue&type=script&lang=js"
export * from "./studioDashboardEmployeeTargetHoursDialog.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardEmployeeTargetHoursDialog.vue?vue&type=style&index=0&id=56239175&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56239175",
  null
  
)

export default component.exports